import store from '@/store';
import aplCatlCode from '@/json/aplCatlCode';

export function isAplCatlA3() {
    return store.state?.permissions?.aplCatl === aplCatlCode.A3;
}

export function isAplCatlA4() {
    return store.state?.permissions?.aplCatl === aplCatlCode.A4;
}

export function isAplCatlA5() {
    return store.state?.permissions?.aplCatl === aplCatlCode.A5;
}

export function isAplCatlA6() {
    return store.state?.permissions?.aplCatl === aplCatlCode.A6;
}

export function isAplCatlPayAcc() {
    return store.state?.permissions?.aplCatl === aplCatlCode.PAY_PCC;
}

export function isAplCatlA3A4A5() {
    return isAplCatlA3() || isAplCatlA4() || isAplCatlA5() || isAplCatlA6();
}
